import api from '@/api/superAdmin'

const state = {

}

const actions = {
  getSuperAdminCompanyList (context, params) {
    return api.getSuperAdminCompanyList(params)
  },
  getHRAccountList (context, params) {
    return api.getHRAccountList(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
